export default "__VITE_PUBLIC_ASSET__bec4f1b8__"